<template>
  <div class="role-dialog">
    <el-dialog
      width="1000px"
      :visible.sync="dialogShow"
      title="所属机构信息"
      :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <el-form
          class="form"
          :model="formData"
          :rules="rules"
          ref="dialogForm"
          label-width="150px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="角色名称" prop="roleCode">
                <el-select
                  class="full-width"
                  v-model="formData.roleCode"
                  :disabled="type!=='add'"
                  @change="
                    roleChange(
                      roleList.find(
                        (item) => item.roleCode === formData.roleCode
                      )
                    )
                  "
                >
                  <el-option
                    :label="item.roleName"
                    :value="item.roleCode"
                    v-for="item in roleList"
                    :key="item.roleCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色用户关联状态" prop="enabled">
                <el-select class="full-width" v-model="formData.enabled">
                  <el-option label="生效" :value="true"></el-option>
                  <el-option label="失效" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="默认角色" prop="defaultRole">
                <el-radio-group
                  class="full-width"
                  v-model="formData.defaultRole"
                  :disabled="type!=='add'"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="dialog-footer text-center" slot="footer">
        <el-button class="dilink-primary-btn" v-if="type !== 'view'" @click="submitCheck"
          >提交</el-button
        >
        <el-button class="ml20" @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { roleList, opUserRoleAdd, opUserRoleSave } from "@/http/usercenter.js";
export default {
  data() {
    return {
      type: 'add',
      dialogShow: false,
      formData: {
        defaultRole: false,
        enabled: true,
        roleCode: "",
        roleName: "",
      },
      rules: {
        defaultRole: [{required: true, trigger: 'blur', message: '请选择'}],
        enabled: [{required: true, trigger: 'blur', message: '请选择'}],
        roleCode: [{required: true, trigger: 'blur', message: '请选择'}],
      },
      roleList: [],
      userNo: "",
    };
  },
  methods: {
    roleChange(role) {
      this.formData.roleName = role.roleName;
    },
    submitCheck() {
      this.$refs.dialogForm.validate((result) => {
        if (result) {
          let handleFun = opUserRoleAdd;
          const data = {
            ...this.formData,
            userNo: this.userNo ? this.userNo : null,
          };
          if (this.type === "edit") {
            handleFun = opUserRoleSave;
            delete data.userNo
          }
          handleFun(data)
            .then((res) => {
              
              if (res.ret === 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.$emit("success");
                this.closeDialog();
              }
            })
        }
      });
    },
    getRoleList() {
      roleList({
        pageData: { total: 0, currentPage: 1, page: 1, pageSize: "10000" },
        filterData: { roleType: "op" },
      })
        .then((res) => {
          if (res.ret === 0) {
            this.roleList = [...res.data.content];
          }
        })
    },
    closeDialog() {
      // 关闭弹窗
      this.formData = { defaultRole: false, enabled: true, roleCode: "" };
      this.$refs.dialogForm.clearValidate();
      this.dialogShow = false;
    },
  },
};
</script>
<style lang="less" scoped></style>
